import { Button, IconEye } from '@vtex/admin-ui'
import { useAdmin } from '@vtex/raccoon-next'
import { useCoupons } from 'hooks'
import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { TextSpinner } from '../../../..'
import { buildSearchParams } from '../../../../utils'
import styles from './coupons.css'
import { messages } from './messages'

interface Props {
  utmSource: string[]
  utmCampaign: string[]
}

export function LinkedCoupons(props: Props) {
  const { utmSource, utmCampaign } = props

  const hasUTMs = Boolean(utmSource.length || utmCampaign.length)

  const { countCouponsByUTM, isLoading, isRefetching } = useCoupons({
    enabled: hasUTMs,
    queryKey: ['coupons-by-utm'],
    refetchOnWindowFocus: true,
  })

  const couponsCount = useMemo<number>(
    () =>
      hasUTMs && !isLoading
        ? countCouponsByUTM({ utmSource, utmCampaign }) ?? 0
        : 0,
    [countCouponsByUTM, hasUTMs, isLoading, utmCampaign, utmSource]
  )

  const { formatMessage: i18n } = useIntl()
  const { account } = useAdmin()

  const linkedCouponsQuantity: number = hasUTMs ? couponsCount : 0

  const openListUrl = () => {
    const url = new URL(`https://${account}.myvtex.com/admin/coupons`)
    url.search = buildSearchParams({ utmSource, utmCampaign })

    window.open(url.toString(), '_blank')
  }

  return (
    <Button
      variant="neutralTertiary"
      icon={<IconEye />}
      disabled={linkedCouponsQuantity === 0}
      className={styles.cursorOnDisabled}
      onClick={openListUrl}
    >
      {i18n(messages.linked, {
        value: linkedCouponsQuantity,
        loading: isLoading || isRefetching,
        spinner: <TextSpinner variant="action1" />,
      })}
    </Button>
  )
}
